import { createContext, useContext, useState, useCallback } from "react";

const CompareContext = createContext();

export function CompareProvider({ children }) {
  const [selected, setSelected] = useState([]);

  const toggle = useCallback((property) => {
    setSelected((prev) => {
      const exists = prev.find((p) => p.id === property.id);
      if (exists) return prev.filter((p) => p.id !== property.id);
      if (prev.length >= 3) return prev;
      return [...prev, property];
    });
  }, []);

  const clear = useCallback(() => setSelected([]), []);

  const isSelected = useCallback((id) => selected.some((p) => p.id === id), [selected]);

  return (
    <CompareContext.Provider value={{ selected, toggle, clear, isSelected }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  return useContext(CompareContext);
}
